// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { useIsSimpleRequestQuoteEnabled } from "@store/Framework/Store/Context/ContextHooks";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";
import ProductListExportPriceList, {
    ProductListExportPriceListPresentationProps,
} from "@store/Library/Components/ProductList/ProductListExportPriceList";
import { filtersProps } from "@store/Themes/common/props/filters";

const enum fields {
    selectReportId = "selectReportId",
}

export interface ProductListFiltersExportPriceListProps extends WidgetProps {
    fields: {
        [fields.selectReportId]: string;
    };
}

export interface ProductListFiltersExportPriceListStyles {
    wrapper?: InjectableCss;
    exportPriceList?: ProductListExportPriceListPresentationProps;
}

const productListFiltersExportPriceListStyles: ProductListFiltersExportPriceListStyles = {
    wrapper: {
        css: css`
            ${spacingStyles(null, filtersProps.spacing)}
        `,
    },
    exportPriceList: {
        extendedStyles: {
            button: {
                variant: "text" as any,
                mergeCss: true,
                css: css`
                    width: 100%;
                `,
            },
        },
    },
};

const styles = productListFiltersExportPriceListStyles;

const ProductListFiltersExportPriceList: FC<ProductListFiltersExportPriceListProps> = ({
    fields: { selectReportId },
}) => {
    const isSimpleRequestQuoteEnabled = useIsSimpleRequestQuoteEnabled();
    const onlyGreifProducts = useAppSelector(state => state.pages.productList.productFilters.onlyGreifProducts);

    if (!isSimpleRequestQuoteEnabled || onlyGreifProducts) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <ProductListExportPriceList {...styles.exportPriceList} reportId={selectReportId} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ProductListFiltersExportPriceList,
    definition: {
        group: "Product List",
        displayName: "Download Price List Button (Filters)",
        allowedContexts: ["ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.selectReportId,
                displayName: "ReportId For Button Navigation",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "d2f23299-d05a-4c1d-a19d-99ac1e35fe6b",
                tooltip:
                    "Please put the report Id from the reports page dropdown,to navigate to the specific option on button click",
            },
        ],
    },
};

export default widgetModule;
